import React, { FC, useState } from 'react'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  list: any[];
}

const minLen: number = 3

const StoreShow: FC<IProps> = (props: IProps) => {
  const { list } = props
  const [show, setShow] = useState<boolean>(false)
  return (
    <div className='store-show'>
      {list.length === 0 && <div className='store-span'>{i18n.t('decoration.noStore')}</div>}
      {
        list.slice(0, show ? list.length : minLen).map((item: any, index: any) => (
          <div className='store-span' key={index}>{item}</div>
        ))
      }
      {list.length > minLen && <div className='show-all' data-cypid='storeShow' onClick={() => setShow(!show)}>{show ? i18n.t('mkt.common.putAway') : i18n.t('mkt.common.viewAll')}</div>}
    </div>
  )
}
export default StoreShow
